export const HUB_SCOPED_ROLES = ['OPERATIONS'];
export const HUB_OVERRIDING_ROLES = ['ADMIN'];

export const isHubPickerApplicable = (roles: string[] = []): boolean => {
  if (roles.some((r) => HUB_OVERRIDING_ROLES.includes(r))) {
    return false;
  }
  return roles.some((r) => HUB_SCOPED_ROLES.includes(r));
};
